import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('TAG_MODERATIONS_QUALIFICATION_WARNING').plugin(axiosPlugin);
let fetchAction = redux.fetchActionGetOne();


export const TYPES = redux.types;

export const fetchTagModerationQualificationWarningLevel = () => fetchAction(`/tag-moderations/qualifications/warning-level`);
export const resetTagModerationQualificationWarningLevel = () => redux.actions.reset();

export const tagModerationQualificationWarningLevel = redux.reducer();